

import { Flex } from '@chakra-ui/react';
import { FieldLabel } from '../Field';
import { Checkbox } from '@morressier/alembic';
import { parseStringWithLinks } from 'src/utils/parseStringWithLinks';

const ComplianceReview = ({ config, value }: { config: any, value: boolean }) => {
  const {
    name,
    params: { validations, labels }
  } = config;

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        isRequired={validations.required}
        label={labels.main}
        subText={''}
        helpText={labels.helpText}
      />
      <Checkbox
        ariaLabel={labels.main}
        id={name}
        isChecked={value}
        isDisabled
        name={name}
      >
        {parseStringWithLinks(labels.subtitle)}
      </Checkbox>
    </Flex>
  );
}

export default ComplianceReview
